import { render } from "./VabChartRadar.vue?vue&type=template&id=178035d8"
import script from "./VabChartRadar.vue?vue&type=script&lang=js"
export * from "./VabChartRadar.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/other/echarts/components/VabChartRadar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "178035d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('178035d8', __exports__)) {
    console.log('reload')
    api.reload('178035d8', __exports__)
  }
  
  module.hot.accept("./VabChartRadar.vue?vue&type=template&id=178035d8", () => {
    console.log('re-render')
    api.rerender('178035d8', render)
  })

}


export default __exports__